import React from 'react';
import PagesHeader from './PagesHeader';
import { generateComponentDocs, generateStoryDocs } from '../../utils/documentationUtils';

export default {
  title: 'Components/Headers/PagesHeader',
  component: PagesHeader,
  parameters: {
    layout: 'fullscreen',
    ...generateComponentDocs(
      // What problem does it solve?
      '\nThe `PagesHeader` component is used to display a page header with an icon and a title. It ensures consistency in header styling across different pages.\n\n',
      // When & how to use it?
      '\nUse the `PagesHeader` component to render a page title with an optional icon. This component is typically placed at the top of the page to indicate its purpose.\n\n',
      // Current Usage
      '\nThe `PagesHeader` component is used on various pages to display the page name along with an associated icon.\n\n',
      // Related Components
      '\n- **[Icon](http://localhost:6006/?path=/docs/components-icons-icon--docs)**: Component used within PagesHeader to render the icon.\n\n',
    ),
  },
  tags: ['autodocs'],
  argTypes: {
    name: {
      control: { type: 'text' },
      description: 'The name of the icon to display next to the page title.\n\n',
      table: {
        type: { summary: 'string' },
        required: true,
      },
    },
    label: {
      control: { type: 'text' },
      description: 'The title of the page.\n\n',
      table: {
        type: { summary: 'string' },
        required: true,
      },
    },
    size: {
      control: { type: 'text' },
      description: 'Optional prop to adjust the size of the icon.\n\n',
      table: {
        type: { summary: 'string' },
        required: false,
      },
    },
  },
};

const Template = (args) => <PagesHeader {...args} />;

export const UsersPage = Template.bind({});
UsersPage.args = {
  name: 'users',
  label: 'Users',
};
UsersPage.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThis variant is used to display the header for the Users page, showing the page title along with an associated icon.\n\n',
  // Where is it currently used on the product?
  '\nThe `PagesHeader` component is used at the top of the Users page to display the title and icon.\n\n',
);

export const NotesPage = Template.bind({});
NotesPage.args = {
  name: 'notes',
  label: 'Notes',
  size: '36px',
};
NotesPage.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThis variant is used to display the header for the Notes Page, showing the page title along with an associated icon.\n\n',
  // Where is it currently used on the product?
  '\nThe `PagesHeader` component is used at the top of the Notes Page to display the title and icon.\n\n',
);

export const TagsPage = Template.bind({});
TagsPage.args = {
  name: 'tags',
  label: 'Tags',
  size: '36px',
};
TagsPage.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThis variant is used to display the header for the Tags Page, showing the page title along with an associated icon.\n\n',
  // Where is it currently used on the product?
  '\nThe `PagesHeader` component is used at the top of the Tags Page to display the title and icon.\n\n',
);

